export const formDataToObject = formData => {
  const data = {}
  formData.forEach((value, key) => {
    data[key] = value
  })
  return data
}
export function formatUrl (url) {
  return url
    ?.replace('https://www.youtube.com/shorts/', '')
    .replace('https://www.youtube.com/watch?v=', '')
    .split('&')[0]
}

export function setMargin (margin_selection={}) {
  const {
    margin_top,
    margin_bottom,
    margin_left,
    margin_right,
    margin,
    margin_select,
    link_margins
  } = margin_selection
  const customSeperateMargin = `${margin_top}px ${margin_right}px ${margin_bottom}px ${margin_left}px`
  const customMargins = `${margin}px`
  const customMargin = link_margins ? customMargins : customSeperateMargin

  switch (margin_select) {
    case 'custom margin':
      return customMargin
    default:
      return false
  }
}

export function setPadding (padding_selection={}) {
  const {
    padding_top,
    padding_bottom,
    padding_left,
    padding_right,
    padding,
    padding_select,
    link_paddings
  } = padding_selection
  const customSeperatepadding = `${padding_top}px ${padding_right}px ${padding_bottom}px ${padding_left}px`
  const customPaddings = `${padding}px`
  const customPadding = link_paddings ? customPaddings : customSeperatepadding

  switch (padding_select) {
    case 'custom padding':
      return customPadding
    default:
      return false
  }
}
export function getHeaderSize (headerSize) {
  switch (headerSize) {
    case 'header1':
      return 'text-header1'
    case 'header2':
      return 'text-header2'
    case 'header3':
      return 'text-header3'
    case 'header4':
      return 'text-header4'
    case 'header5':
      return 'text-header5'
    case 'header6':
      return 'text-header6'
    default:
      return 'text-header1'
  }
}

export const transitionViewIfSupported = updateCb => {
  if (document.startViewTransition) {
    document.startViewTransition(updateCb)
  } else {
    updateCb()
  }
}
